import moment from 'moment';

export const calcDistanceTraveled = (startKm: number, endKm: number): string =>
  (endKm - startKm).toFixed(2);

export const calcDurationDrive = ({
  startDate,
  startTime,
  endDate,
  endTime,
}: {
  startDate: Date;
  startTime: string;
  endDate: Date;
  endTime: string;
}): string => {
  const start = moment(
    `${moment(startDate).format('YYYY-MM-DD')} ${startTime}`,
    'YYYY-MM-DD HH:mm',
  );
  const end = moment(`${moment(endDate).format('YYYY-MM-DD')} ${endTime}`, 'YYYY-MM-DD HH:mm');
  const duration = moment.duration(end.diff(start)).asMinutes();

  if (duration < 0 || duration > 6000) {
    return '00:00';
  }

  const fullHours = Math.floor(duration / 60);
  const hours = fullHours > 10 ? fullHours : `0${fullHours}`;
  const minutes = duration % 60 > 10 ? (duration % 60).toString() : `0${duration % 60}`;

  return `${hours}:${minutes}`;
};
